"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { motion } from "framer-motion";
const EASE: [number, number, number, number] = [0.25, 0.1, 0.25, 1];

// Matches the live site's WOW.js `data-wow-delay` values for this exact
// 9-card grid (rows 1-2 stagger .2/.4/.6s, row 3 is .6s across the board).
const WOW_DELAYS = [0.2, 0.4, 0.6, 0.2, 0.4, 0.6, 0.6, 0.6, 0.6];
interface FeatureCardProps {
  icon: string;
  title: string;
  description: string;
  index?: number;
}
export default function FeatureCard(t0) {
  const $ = _c(27);
  const {
    icon,
    title,
    description,
    index: t1
  } = t0;
  const index = t1 === undefined ? 0 : t1;
  const desktopAnimations = useDesktopAnimations();
  const delay = WOW_DELAYS[index] ?? (index % 3 === 0 ? 0.2 : index % 3 === 1 ? 0.4 : 0.6);
  let t2;
  if ($[0] !== desktopAnimations) {
    t2 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== desktopAnimations) {
    t3 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== desktopAnimations) {
    t4 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      once: true,
      amount: 0
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== desktopAnimations) {
    t6 = desktopAnimations ? {
      y: -8,
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    } : undefined;
    $[7] = desktopAnimations;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== delay) {
    t7 = {
      duration: 1,
      delay,
      ease: EASE
    };
    $[9] = delay;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== icon || $[12] !== title) {
    t8 = <Image src={icon} alt={title} width={80} height={80} priority={false} className="mb-6 h-[70px] w-[70px] object-contain transition-transform duration-500 group-hover:scale-110" />;
    $[11] = icon;
    $[12] = title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== title) {
    t9 = <h3 className="text-lg font-bold text-[#050748] transition-colors duration-300 group-hover:text-white dark:text-white">{title}</h3>;
    $[14] = title;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== description) {
    t10 = <p className="mt-4 text-lg font-open-sans leading-6 text-[#7782a6] transition-colors duration-300 group-hover:text-white dark:text-gray-400">{description}</p>;
    $[16] = description;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t11 = <motion.div initial={t2} whileInView={t3} animate={t4} viewport={t5} whileHover={t6} transition={t7} className="group flex h-[350px] w-full max-w-[400px] flex-col items-center justify-center rounded border border-[#d8eaff] bg-white px-6 py-8 text-center shadow-[0_10px_30px_rgba(0,0,0,0.03)] transition-colors duration-500 hover:border-transparent hover:bg-gradient-to-br hover:from-[#ffb26b] hover:via-[#ff5b8d] hover:to-[#ff2f8a] dark:border-gray-800 dark:bg-gray-900 dark:shadow-black/20">{t8}{t9}{t10}</motion.div>;
    $[18] = t10;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}